
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PositionBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locales"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"positionBySlug"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"locales"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locales"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"names"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csCz"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"daDk"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deCh"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deDe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enAu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enCa"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enGb"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enIe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enNz"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enUs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"esAr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"esCl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"esCo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"esEs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"esMx"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"esPe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fiFi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"frBe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"frCh"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"frFr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"frLu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"huHu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itCh"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itIt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jaJp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nbNo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nlBe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nlNl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plPl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ptBr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ptPt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ruRu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"svSe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"trTr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zhCn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zhHk"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":570}};
    doc.loc.source = {"body":"query PositionBySlug($slug: String!, $locales: [String!]!) {\n  positionBySlug(slug: $slug, locales: $locales) {\n    id\n    name\n    names {\n      csCz\n      daDk\n      deAt\n      deCh\n      deDe\n      enAu\n      enCa\n      enGb\n      enIe\n      enIn\n      enNz\n      enUs\n      esAr\n      esCl\n      esCo\n      esEs\n      esMx\n      esPe\n      fiFi\n      frBe\n      frCh\n      frFr\n      frLu\n      huHu\n      itCh\n      itIt\n      jaJp\n      nbNo\n      nlBe\n      nlNl\n      plPl\n      ptBr\n      ptPt\n      ruRu\n      svSe\n      trTr\n      zhCn\n      zhHk\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PositionBySlug"] = oneQuery(doc, "PositionBySlug");
        
